// TODO (GB-12544): update to use shared/ui/gb-image.component

import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ImagesEntity } from 'libs/gb-dashboard/shared/data-access-images/src'

@Component({
  selector: 'gb-image',
  templateUrl: './gb-image.component.html',
  styleUrls: ['./gb-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbImageComponent {
  @Input({ required: true }) image!: ImagesEntity
  @Input() cover = false
  @Input() useThumbnail = false

  get objectFit(): string {
    return this.cover ? 'cover' : 'contain'
  }
}
